import { render } from "./FormTabsBlockComponent.vue?vue&type=template&id=cc4ca98c&scoped=true"
import script from "./FormTabsBlockComponent.vue?vue&type=script&lang=js"
export * from "./FormTabsBlockComponent.vue?vue&type=script&lang=js"

import "./FormTabsBlockComponent.vue?vue&type=style&index=0&id=cc4ca98c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc4ca98c"]])

export default __exports__